import React from 'react';
import { Check, CheckCheck } from 'lucide-react';

const TickIcon = ({ status }) => {
  const size = 16;
  const gray = '#9ca3af'; // neutral gray for sent/delivered
  const blue = '#53bdeb'; // blue for read only

  switch (status) {
    case 'sending':
      return <Check size={size} color="#c7c7c7" />; // very light gray
    case 'sent':
      return <Check size={size} color={gray} />; // single gray check
    case 'delivered':
      return <CheckCheck size={size} color={gray} />; // double gray checks
    case 'read':
      return <CheckCheck size={size} color={blue} />; // double blue checks
    case 'failed':
      return <span title="Failed" style={{ color: '#ef4444', fontWeight: 700 }}>!</span>;
    default:
      return null;
  }
};

export default TickIcon;
